import {
  GenerateManualPayload_manual_generateManualPayload_skuPositions_values_value,
} from '@src/app/generated/GenerateManualPayload';
import { PlacementInformation } from '@src/app/model/placement-information';
import { PlacementInfoMap } from '@src/app/model/placement-info-map';

export class SKUInfo {
  placementInfoMap: PlacementInfoMap[];
  purchasePrice?: number;

  constructor(placementInfoMap: PlacementInfoMap[], purchasePrice?: number) {
    this.placementInfoMap = placementInfoMap;
    this.purchasePrice = purchasePrice;
  }

  static fromGql(input: GenerateManualPayload_manual_generateManualPayload_skuPositions_values_value): SKUInfo {
    if (input) {
      return new SKUInfo(
        input.placementInfoMap.map(x => new PlacementInfoMap(x.id, x.markers.map(PlacementInformation.fromGql))),
        input.purchasePrice
      );
    }
  }
}
